// import { useSelector , useDispatch} from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { Link } from "react-router-dom";
// import React, { useEffect, useState } from "react";
// import MenuCard from "../../component/MenuCard";
// import VegIcon from "../../Assets/vegIcon.png"
// import NonVegIcon from "../../Assets/nonVegIcon.png"
// import Egg from "../../Assets/egg.png"
// import '../../component/ListItem/listItem.scss'
// import './cartPage.scss'
// import LoginPage from "../Login";
// import OrderPinPopup from "../../component/OrderPinPopup/OrderPinPopup";
// import { diet } from "../../Utills/enums";
// import { placeOrder, clearCart } from '../../redux/action';
// import EmptyHungryPage from "../../component/EmptyHungry/EmptyHungryPage";

// const CartPage = () => {

//     const { restaurant, id, table, currency = '₹' } = useParams()
//     const menuList = useSelector((state) => state?.user.menu);
//     const cart = useSelector((state) => state?.user.cart);
//     const user = useSelector((state) => state?.user.user);
//     const redirectTo = useSelector(state => state.user.redirectTo);
//     const [showPinPopup, setShowPinPopup] = useState(false);
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     let sessionAllInfo = null;

//   console.log("cart",cart)
//    console.log("CartPage user",user)
//   try {
//     const data = localStorage.getItem('allInfo');
//     sessionAllInfo = data ? JSON.parse(data) : null;
//   } catch (error) {
//      console.error("Invalid JSON in localStorage", error);
//   }
//   const tableOtp = sessionAllInfo?.tableOtp;

//     useEffect(() => {

//       console.log("redirectTo",redirectTo)
//       if (!redirectTo) return;

//        if (redirectTo === "MENU") {
//          dispatch(clearCart());
//         navigate(`/${restaurant}/${id}/${table}/order-placed`);
//       }

//       dispatch({ type: "CLEAR_REDIRECT" }); // reset redirect
//     }, [redirectTo]);

//     const cartItems = () => {
//         const items = []
//         Object.values(cart).map(c => {
//             let item = menuList?.categories.find(cat => cat.categoryId === c.selectedTab)
//                 .items.find(item => item.menuId === c.id);
//             items.push({ ...item, selectedTab: c.selectedTab, selected: c.selected, note: c.note})
//         })
//         return items ? items : <div> All cought </div>
//     };

//     const getTotalPrice = () => {
//         let amount = 0
//         Object.values(cart).map((val) => {
//             amount += val.price * val.selected;
//         })
//         return amount;
//     };

//     const itemList = cartItems();
//     const totalPrice = getTotalPrice()

//   const getOrderData = (pin) => {
//   if (!itemList || !user) return [];

//   return Object.values(itemList).map(val => ({
//     menuId: val.menuId,
//     quantity: val.selected,
//     tableOtp: pin ?? tableOtp ?? "",
//     qRScanLogId:  sessionAllInfo?.qrScanLogId ?? null,
//     note: val.note
//   }));
// };

// console.log("getOrderData",getOrderData())
// console.log("itemList",itemList)

//   const handlePlaceOrder = () => {
//     if(!tableOtp)
//       setShowPinPopup(true);
//     else
//       dispatch(placeOrder(getOrderData()));
//       //dispatch({ type: "PLACE_ORDER", payload : getOrderData() });
//   };

//   const handlePinSubmit = (pin) => {
//     console.log("PIN entered:", pin);

//     // TODO: API CALL to place order
//     // await submitOrder(pin);
//      dispatch(placeOrder(getOrderData(pin)));

//     setShowPinPopup(false);

//     //alert("Order placed successfully!");
//   };

//    const goBack = () => {
//   navigate(-1); // goes back to previous page
// };

//     return (!user ? <LoginPage /> : <div className="cartPage lrSpace">
//         <h2 style={styles.cartButton} onClick={goBack}>  <span title="go back" style={styles.backButton}> &lt; Cart</span>
//         </h2>
//         <ul className="no-bullets">
//             {/* todo: on click animation */}
//             {itemList.length === 0 ? <div style={{ marginTop: "10%" }}> No Items to show.</div> : itemList.map((val) =>
//                 <MenuCard
//                     key={val.menuId}
//                     menuId={val.menuId}
//                     src={val.imageUrl}
//                     title={val.foodName}
//                     description={val.description}
//                     price={val.price}
//                     dietIcon={diet[val.foodTypeId] === "Veg" || diet[val.foodTypeId] === "Vegan"? VegIcon
//                     : diet[val.foodTypeId] === "Egg"? Egg : NonVegIcon}
//                     tab={val?.selectedTab}
//                     unit={val}
//                     isAvailable={val?.isAvailable}
//                     note={val?.note}
//                     showNote={true}
//                 />
//             )}
//         </ul>

//         {/* <div>Offers and Benifits</div> */}
//         {itemList.length > 0 ? (
//   <>
//   <div className="payment-summary">
//        {/*  <div className="payTitle">Payment Summary</div>
//      <div className="priceRow">
//       <div className="yyy">Subtotal</div>
//       <div className="zzz"><b>{currency} {totalPrice}</b></div>
//     </div> */}
//     {/* <div className="priceRow theameColor">
//       <div className="yyy">Discount</div>
//       <div className="zzz">{currency} 50</div>
//     </div>
//     <div className="priceRow">
//       <div className="yyy">Service Charges</div>
//       <div className="zzz">{currency} 20</div>
//     </div>
//     <div className="priceRow">
//       <div className="yyy"><b>Total amount</b></div>
//       <div className="zzz"><b>{currency} {totalPrice + 20 - 50}</b></div>
//     </div> */}
//   </div>
//   </>
// ) : (

//  <EmptyHungryPage/>
// )}

//   {/* Bottom Sticky Bar */}
// {itemList.length > 0 && (

//   <div className="bottom-bar" style={styles.bottomBar}>
//   <div style={styles.itemCount}>{itemList.length} Items</div>

//    <button
//     style={styles.placeOrderBtn}
//     onClick={handlePlaceOrder}
//   >
//     <span style={{ marginRight: 8 }}>🛒</span>
//     Place Order
//   </button>

//   <OrderPinPopup
//         isOpen={showPinPopup}
//         onClose={() => setShowPinPopup(false)}
//         onSubmit={handlePinSubmit}
//       />
// </div>

// )}

//   </div>)
// }

// const styles = {
//   bottomBar: {
//     position: "fixed",
//     bottom: 0,
//     left: 0,
//     right: 0,
//     padding: "5px 16px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     borderTop: "1px solid #e4e4e4",
//     zIndex: 999,
//     boxShadow: "0 -2px 10px rgba(0,0,0,0.05)",
//     marginTop: 10
//   },

//   itemCount: {
//     padding: "12px 20px",
//     color: "#fff",
//     borderRadius: "10px",
//     fontSize: "16px",
//     fontWeight: "500",
//   },

//   placeOrderBtn: {
//     padding: "12px 20px",
//     backgroundColor: "#fff",
//     color: "#FB6236",
//     border: "none",
//     borderRadius: "10px",
//     fontSize: "16px",
//     fontWeight: "600",
//     display: "flex",
//     alignItems: "center",
//     cursor: "pointer",
//   },
//   backButton: {
//     cursor: "pointer",
//     fontSize: "20px",
//     fontWeight: "600",
//     marginBottom: "10px",
//     width: "fit-content",
//     padding: "0px 2px",
//     color:"rgb(251, 98, 54)"
//   },
//   cartButton: {
//   fontSize: "16px",
//   textAlign: "justify",
//   color:"rgb(251, 98, 54)"
//   }
// };

// export default CartPage;

import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import MenuCard from "../../component/MenuCard";
import VegIcon from "../../Assets/vegIcon.png";
import NonVegIcon from "../../Assets/nonVegIcon.png";
import Egg from "../../Assets/egg.png";
import "../../component/ListItem/listItem.scss";
import "./cartPage.scss";
import LoginPage from "../Login";
import OrderPinPopup from "../../component/OrderPinPopup/OrderPinPopup";
import { diet } from "../../Utills/enums";
import { placeOrder, clearCart, fetchMenuData } from "../../redux/action";
import EmptyHungryPage from "../../component/EmptyHungry/EmptyHungryPage";
import { canOrderItem } from "../../Utills/menuAvailability";
import { toast } from "react-toastify";
import IconButton from "../../component/Buttons/IconButton";

const CartPage = () => {
  const { restaurant, id, table, currency = "₹" } = useParams();
  const menuList = useSelector((state) => state?.user.menu);
  const cart = useSelector((state) => state?.user.cart);
  const user = useSelector((state) => state?.user.user);
  const redirectTo = useSelector((state) => state.user.redirectTo);
  const [showPinPopup, setShowPinPopup] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let sessionAllInfo = null;

  console.log("cart", cart);
  console.log("CartPage user", user);

  try {
    const data = localStorage.getItem("allInfo");
    sessionAllInfo = data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Invalid JSON in localStorage", error);
  }
  const tableOtp = sessionAllInfo?.tableOtp;

  useEffect(() => {
    if ((!menuList?.categories || menuList.categories.length === 0) && id) {
      dispatch(fetchMenuData(id));
    }
  }, [menuList, id, dispatch]);

  useEffect(() => {
    console.log("redirectTo", redirectTo);
    if (!redirectTo) return;

    if (redirectTo === "MENU") {
      dispatch(clearCart());
      navigate(`/${restaurant}/${id}/${table}/order-placed`);
    }

    dispatch({ type: "CLEAR_REDIRECT" }); // reset redirect
  }, [redirectTo]);

  const hasCartEntries = Object.keys(cart).length > 0;
  const isMenuLoading =
    hasCartEntries &&
    (!menuList?.categories || menuList.categories.length === 0);

  // ✅ FIXED: Prioritize the selected price and variant details from the active cart state
  const cartItems = () => {
    const items = [];
    if (!menuList?.categories) return items;
    Object.values(cart).forEach((c) => {
      const category = menuList?.categories.find(
        (cat) => cat.categoryId === c.selectedTab,
      );
      const originalItem = category?.items.find((item) => item.menuId === c.id);

      if (originalItem) {
        items.push({
          ...originalItem, // Keeps structural fields like imageUrl, description, foodTypeId
          ...c, // Overrides price, selected counts, note, and custom variant metadata safely
          isAvailable: originalItem.isAvailable,
          canOrder: originalItem.canOrder,
          availabilityValidUntil: originalItem.availabilityValidUntil,
          availabilityMessage: originalItem.availabilityMessage,
          menuId: originalItem.menuId, // Anchor link target identification
        });
      }
    });
    return items;
  };

  const getTotalPrice = () => {
    let amount = 0;
    Object.values(cart).forEach((val) => {
      amount += val.price * val.selected;
    });
    return amount;
  };

  const itemList = cartItems();
  const totalPrice = getTotalPrice();

  // ✅ FIXED: Map sizeOptionId payloads into your order transmission schema for your backend
  const getOrderData = (pin) => {
    if (!itemList || !user) return [];

    return itemList.map((val) => ({
      menuId: val.menuId,
      quantity: val.selected,
      tableOtp: pin ?? tableOtp ?? "",
      qRScanLogId: sessionAllInfo?.qrScanLogId ?? null,
      note: val.note,
      // Pass the custom item variant selection options down downstream safely
      sizeOptionId: val.variant ? val.variant.sizeOptionId : null,
    }));
  };

  console.log("getOrderData", getOrderData());
  console.log("itemList", itemList);

  const handlePlaceOrder = () => {
    if (!validateCartAvailability()) return;
    if (!tableOtp) setShowPinPopup(true);
    else dispatch(placeOrder(getOrderData()));
  };

  const handlePinSubmit = (pin) => {
    if (!validateCartAvailability()) return;
    console.log("PIN entered:", pin);
    dispatch(placeOrder(getOrderData(pin)));
    setShowPinPopup(false);
  };

  const goBack = () => {
    navigate(-1); // goes back to previous page
  };

  function validateCartAvailability() {
    if (!itemList.length || itemList.length !== Object.keys(cart).length || itemList.some(item => !canOrderItem(item))) {
      toast.warn("Some items are unavailable. Please update your cart.");
      dispatch(fetchMenuData(id));
      return false;
    }
    return true;
  }

  if (!user) return <LoginPage />;

  // Wait for menuList to load instead of flashing "No items to show"
  if (isMenuLoading) {
    return (
      <div
        className="cartPage lrSpace"
        style={{ textAlign: "center", marginTop: "20%" }}
      >
        <p>Loading your cart...</p>
      </div>
    );
  }

  return (
    <div>
      <header className="cartPage__header">
        <h1 className="cartPage__heading">
          <IconButton 
          onClick={goBack} 
          aria-label="Back" 
          title="Back" 
          label="Back"
          value="Cart"
           />
          {/* <span>Cart</span> */}
        </h1>
      </header>
    <div className="cartPage lrSpace">
      <ul className="no-bullets">
        {itemList.length === 0 ? ( <></>
          // The screen already has a dedicated EmptyHungryPage component for this case, so we can skip rendering a separate message here.
          // <div style={{ marginTop: "10%" }}> No Items to show.</div>
        ) : (
          itemList.map((val) => (
            <MenuCard
              // ✅ FIXED: Pass key and unit variables through unique custom composite keys
              key={val.cartKey}
              menuId={val.menuId}
              src={val.imageUrl}
              title={val.foodName}
              description={val.description}
              price={val.price} // Accurately displays chosen custom variant configuration price
              dietIcon={
                diet[val.foodTypeId] === "Veg" ||
                diet[val.foodTypeId] === "Vegan"
                  ? VegIcon
                  : diet[val.foodTypeId] === "Egg"
                    ? Egg
                    : NonVegIcon
              }
              tab={val?.selectedTab}
              unit={val} // Delivers cart flags to switch MenuCard gracefully into Cart mode
              isAvailable={val?.isAvailable}
              note={val?.note}
              showNote={true}
            />
          ))
        )}
      </ul>

      {itemList.length > 0 ? (
        <div className="payment-summary">
          {/* Optional summary fields go here */}
        </div>
      ) : (
        <EmptyHungryPage />
      )}

      {/* Bottom Sticky Bar */}
      {itemList.length > 0 && (
        <div className="bottom-bar" style={styles.bottomBar}>
          <div style={styles.itemCount}>{itemList.length} Items</div>

          <button style={styles.placeOrderBtn} onClick={handlePlaceOrder}>
            <span style={{ marginRight: 8 }}>🛒</span>
            Place Order
          </button>

          <OrderPinPopup
            isOpen={showPinPopup}
            onClose={() => setShowPinPopup(false)}
            onSubmit={handlePinSubmit}
          />
        </div>
      )}
    </div>
    </div>
  );
};

const styles = {
  bottomBar: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "5px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid #e4e4e4",
    zIndex: 999,
    boxShadow: "0 -2px 10px rgba(0,0,0,0.05)",
    marginTop: 10,
  },

  itemCount: {
    padding: "12px 20px",
    color: "#fff",
    borderRadius: "10px",
    fontSize: "16px",
    fontWeight: "500",
  },

  placeOrderBtn: {
    padding: "12px 20px",
    backgroundColor: "#fff",
    color: "#FB6236",
    border: "none",
    borderRadius: "10px",
    fontSize: "16px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
};

export default CartPage;
